module.exports = __webpack_public_path__ + "img/20.5cd42b2b.png";